import { ReactElement } from 'react';
import * as React from 'react';

import styles from './boost-status-message.module.scss';
import { ButtonRemake } from '@utmb/design-system/button-remake/ButtonRemake';
import { Insert } from '@utmb/design-system/insert/insert';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Font } from '@utmb/design-system/text/font';
import { IconsEnum } from '@utmb/types/icons';
import { useTranslation } from 'next-i18next';

interface BoostStatusMessageProps {
    openCallback?: () => void;
    value?: boolean;
    percentage?: number;
    label?: string;
}

export const BoostStatusMessage = ({ value, percentage, openCallback, label }: BoostStatusMessageProps): ReactElement => {
    const { t } = useTranslation();

    return (
        <div className={styles.boostStatusMessage + ' ' + (!openCallback ? styles.forceNoWrap : '')}>
            <div className={styles.insert}>
                {value ? (
                    <Insert
                        color={getColorStyle(ColorTypesEnum.PRIMARY)}
                        backgroundColor={'#17ffc2'}
                        label={t('races.preregistration.shortBoost', { pct: percentage })}
                    />
                ) : (
                    <Insert
                        color={getColorStyle(ColorTypesEnum.WHITE)}
                        backgroundColor={getColorStyle(ColorTypesEnum.ORANGE)}
                        label={t('races.preregistration.shortNoBoost')}
                    />
                )}
            </div>

            {label ? (
                <Font.FuturaBook className={styles.label} desktop="16" mobile="16">
                    {label}
                </Font.FuturaBook>
            ) : null}

            {openCallback ? (
                <ButtonRemake
                    customClassName={styles.button}
                    action={() => openCallback()}
                    variant="link"
                    label={t('races.preregistration.editBoostChoice')}
                    icon={IconsEnum.PEN}
                />
            ) : null}
        </div>
    );
};
